import ButtonsEditControl from '../../components/ButtonsEditControl';
import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';

/**
 * returns the Buttons Edit control
 */
export default function getButtonsEditControl(
    onSaveClicked: () => void,
    onDiscardClicked: () => void,
    cardMode: CardMode,
    errorMessage: string
): JSX.Element {
    return ButtonsEditControl({
        onSaveClicked: onSaveClicked,
        onDiscardClicked: onDiscardClicked,
        cardMode: cardMode,
        errorMessage: errorMessage,
    });
}
